import Payslips from "@/views/employee/Payslips";

export default [
    {
        path: '/payslips/:uid',
        name: 'Payslip',
        meta: {layout: 'auth',authRequired:false},
        component: Payslips,
    },
]